import { T } from "../data/content";
import { useLang } from "../context/LangContext";

export const Marquee = () => {
  const { lang } = useLang();
  const words = T.marquee[lang];
  const row = [...words, ...words];

  return (
    <div className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#15100B] py-6" data-testid="marquee">
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
        {[...row, ...row].map((w, i) => (
          <div key={i} className="flex items-center gap-8">
            <span className="font-serif text-3xl italic text-[#F5ECDA]/90 md:text-4xl">{w}</span>
            <span className="text-[#D4AF37] text-lg">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
